import {AppliedDiscount, AppliedDiscountDiscountType} from '@wix/auto_sdk_ecom_current-cart';
import {Discount, DiscountSourceType, DiscountScope} from '@wix/auto_sdk_ecom_cart-v-2';

export class CouponDiscountModel {
  public isFreeShippingCoupon: boolean;

  constructor(params: CouponDiscountModel) {
    this.isFreeShippingCoupon = params.isFreeShippingCoupon;
  }

  public static fromCartV1(appliedDiscounts: AppliedDiscount[]): CouponDiscountModel {
    const discount = appliedDiscounts.find((appliedDiscount) => appliedDiscount?.coupon);
    const coupon = discount?.coupon;

    if (!coupon) {
      return undefined;
    }

    return new CouponDiscountModel({
      isFreeShippingCoupon: discount?.discountType === AppliedDiscountDiscountType.SHIPPING,
    });
  }

  public static fromCartV2(discounts?: Discount[]) {
    const coupon = discounts?.find((discount) => discount.source?.sourceType === DiscountSourceType.COUPON);

    if (!coupon) {
      return undefined;
    }

    return new CouponDiscountModel({
      isFreeShippingCoupon: coupon.scope === DiscountScope.DELIVERY,
    });
  }
}
